import { render } from "./AlertBundle.vue?vue&type=template&id=fb659cd6&scoped=true"
import script from "./AlertBundle.vue?vue&type=script&lang=js"
export * from "./AlertBundle.vue?vue&type=script&lang=js"

import "./AlertBundle.vue?vue&type=style&index=0&id=fb659cd6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb659cd6"]])

export default __exports__